import { GetChildPrice, GetOptions } from 'smg/customer-api/lineitems';
import { DollarFormat } from 'smg/util';
import { tns } from 'tiny-slider';
import { SwiperInit } from '../swiper';

void main();

async function main() {
    const $sliderContainers = Array.from(document.querySelectorAll<HTMLElement>('.feature-slider-container'));
    for (const $sliderContainer of $sliderContainers) {
        const $prevButton = $sliderContainer.parentElement?.querySelector<HTMLElement>('#prev-btn');
        const $nextButton = $sliderContainer.parentElement?.querySelector<HTMLElement>('#next-btn');
        const length = $sliderContainer.children.length;
        if ($sliderContainer && $prevButton && $nextButton) {
            tns({
                container: $sliderContainer,
                items: 6,
                slideBy: 1,
                autoplay: false,
                autoplayButtonOutput: false,
                autoplayHoverPause: true,
                controls: true,
                nav: false,
                mouseDrag: true,
                loop: true,
                prevButton: $prevButton,
                nextButton: $nextButton,
                startIndex: 0,
                responsive: {
                    0: {
                        items: 1,
                    },
                    768: {
                        items: 3,
                    },
                    992: {
                        items: 4,
                    },
                    1200: {
                        items: length < 6 ? length : 6,
                    },
                },
            });
        }
    }

    const callForPriceOpts = new Map<string, string[]>([
        ['lapel pins', ['Custom Printed Card']],
        ['patches', ['Button Loop', 'Safety Pins', 'Peel N Stick', 'Tuxedo Clip']],
        ['medals', ['3D Image']],
    ]);

    const $productOptions = Array.from(document.querySelectorAll<HTMLElement>('.feature-option-name'));
    for (const $productOption of $productOptions) {
        const $optionPrice = $productOption.parentElement?.querySelector<HTMLElement>('.feature-option-price')?.querySelector<HTMLElement>('.price');
        const $lineItem = $productOption.dataset.lineitem;
        const $child = $productOption.dataset.child;
        const $option = $productOption.dataset.option;
        if ($lineItem && $child) {
            if ($option && $optionPrice) {
                if (callForPriceOpts.has($lineItem) && callForPriceOpts.get($lineItem)?.includes($option)) {
                    $optionPrice.textContent = '';
                    continue;
                }
            }
            if (callForPriceOpts.has($lineItem) && callForPriceOpts.get($lineItem)?.includes($child)) {
                if ($optionPrice) {
                    $optionPrice.textContent = '';
                    continue;
                }
            }
            await GetOptions($lineItem, $child).then(async options => {
                if (options.length) {
                    const option = options.find(option => option.name === $option);
                    if (option && $optionPrice) {
                        if (option.networkChildLineItemOption?.price?.gt(0)) {
                            $optionPrice.textContent = `+${DollarFormat(option.networkChildLineItemOption?.price ?? 0)}`;
                        } else {
                            $optionPrice.textContent = 'No Additional Cost';
                        }
                    }
                } else {
                    await GetChildPrice($lineItem, $child).then(price => {
                        if (price && $optionPrice) {
                            if (price.gt(0)) {
                                $optionPrice.textContent = `+${DollarFormat(price)}`;
                            } else {
                                $optionPrice.textContent = 'No Additional Cost';
                            }
                        }
                    });
                }
            });
        }
    }
    SwiperInit();
}